import { render } from "./Item_Select.vue?vue&type=template&id=65482854&scoped=true"
import script from "./Item_Select.vue?vue&type=script&lang=js"
export * from "./Item_Select.vue?vue&type=script&lang=js"

import "./Item_Select.vue?vue&type=style&index=0&id=65482854&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65482854"]])

export default __exports__